<app-informations-administratives-form></app-informations-administratives-form>

<app-mon-panier [commande]="commande" class="mt-5"></app-mon-panier>

<div class="form-check form-switch mt-5">
  <input
    class="form-check-input"
    type="checkbox"
    role="switch"
    [attr.aria-checked]="isCheckboxChecked"
    id="flexSwitchCheckDefault"
    [(ngModel)]="isCheckboxChecked"
  />
  <div>
    <div>
      <label class="form-check-label" for="flexSwitchCheckDefault">
        J'accepte les
      </label>
      <a (click)="openModal(modalId.CGV_MODAL)">
        Conditions générales de vente et d'abonnement.
      </a>
    </div>
    <div>
      Pour information, je consulte la
      <a (click)="openModal(modalId.PDP_MODAL)">
        Politique de données personnelles.
      </a>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center mt-5">
  <p-button
    id="btn-valider"
    label="Valider"
    level="primary"
    [title]="
      !isCheckboxChecked
        ? 'Veuillez accepter les conditions générales avant de valider votre commande'
        : 'Valider la commande'
    "
    [width]="100"
    [loading]="loading"
    [disabled]="loading || !isCheckboxChecked"
    class="col-md-3 m-1"
    (click)="onValiderCommande()"
  ></p-button>
  <p-button
    id="btn-precedent"
    label="Précédent"
    level="secondary"
    type="button"
    [width]="100"
    [disabled]="loading"
    class="col-md-3 m-1"
    (click)="onPrecedent()"
  ></p-button>
</div>

<div class="mt-5 mentions mentions-left">
  <p>
    ADNOV, « Responsable de traitement », traite des données personnelles pour
    la gestion de votre commande. Ce traitement est fondé sur l’exécution d’un
    contrat ou sur l’exécution de mesures précontractuelles.
  </p>

  <p>
    Vos données sont susceptibles d’être communiquées aux destinataires suivants
    :
  </p>
  <ul>
    <li>
      Aux services du Groupe ADSN pour la réalisation du service proposé et
      notamment pour en assurer la facturation
    </li>
    <li>
      À nos sous-traitants pour les seuls besoins de la sous-traitance,
      notamment pour la fourniture de la solution.
    </li>
  </ul>
  <p>
    Ces informations seront conservées pendant toute la durée de la relation
    commerciale. Conformément à la réglementation, vous pouvez accéder aux
    données vous concernant.
  </p>
  <p>
    Le cas échéant, vous pouvez demander la rectification ou l’effacement de
    celles-ci, obtenir la limitation du traitement de ces données ou vous y
    opposer pour des raisons tenant à votre situation particulière. Ces droits
    peuvent être exercés directement auprès du Responsable de traitement ou de
    son Délégué à la protection des données à l’adresse suivante :
    dpo&#64;groupeadsn.fr
  </p>
  <p>
    Si vous pensez, après nous avoir contactés, que vos droits ne sont pas
    respectés, vous pouvez introduire une réclamation auprès d’une autorité
    européenne de contrôle : la Commission Nationale de l’Informatique et des
    Libertés pour la France.
  </p>
</div>

<p-modal
  *ngIf="isModalCgvOpen"
  [modalId]="modalId.CGV_MODAL"
  title="Conditions générales de vente et d'abonnement"
>
  <embed type="application/pdf" [src]="cgvUrl" width="100%" height="500px" />
</p-modal>

<p-modal
  *ngIf="isModalPdpOpen"
  [modalId]="modalId.PDP_MODAL"
  title="Politique de données personnelles"
>
  <embed type="application/pdf" [src]="pdpUrl" width="100%" height="500px" />
</p-modal>
